import { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { useBuildId } from 'modules/common/hooks';
import { useLocalization } from 'localization';
import ImageCarousel from '../carousel/ImageCarousel';

const ASIDE_SLIDES = ['/img/slide1.jpg', '/img/slide2.jpg', '/img/slide3.jpg', '/img/slide4.jpg'];

type Props = {
  children?: ReactNode;
  footer?: ReactNode;
};

const SideLayout = (props: Props) => {
  const { children, footer } = props;
  return (
    <Stack direction="row" width={'100%'} height="100%">
      <Stack flex={1.2} marginBottom={2} gap={1}>
        {children}
        {footer}
        <BuildId />
      </Stack>
      <Stack flex={1} sx={{ display: { sm: 'none', md: 'flex' } }}>
        <ImageCarousel>
          {ASIDE_SLIDES.map(src => (
            <img
              key={src}
              style={{
                backgroundImage: `url(${src})`,
                backgroundSize: 'cover',
                height: '100%',
                width: '100%',
              }}
            />
          ))}
        </ImageCarousel>
      </Stack>
    </Stack>
  );
};

export default SideLayout;

const BuildId = () => {
  const { buildId, onBuildIdClick } = useBuildId();
  const { t } = useLocalization();

  return (
    <Stack onClick={onBuildIdClick} direction="row" gap={1} sx={{ cursor: 'pointer' }} justifyContent={'center'}>
      <Typography variant="body2" color="textSecondary">
        {t('common.terms.buildId')}:
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {buildId}
      </Typography>
    </Stack>
  );
};
